<template>
  <div>
    <!-- 批量转移单子设置： -->
    <el-dialog :title="$t('message.batchTransferOrderSettings')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="780px" center>
      <div class="content">
        <!-- 操作 -->
        <div class="row">
          <div>
            <el-checkbox v-model="order">{{ $t('message.orderForm') }}</el-checkbox>
            <el-checkbox v-model="porder">{{ $t('message.porder') }}</el-checkbox>
          </div>
          <!-- 立即转移 -->
          <el-button size="small" type="primary" @click="save">{{ $t('message.immediateTransition') }}</el-button>
        </div>
        <div class="label">
          转移目标： <span>注意人员如果不需要变更，人员选择框请选择空</span>
        </div>
        <div class="staff">
          <!-- 业务 -->
          <div class="item">
            <el-select v-model="datas.y_id" clearable filterable :placeholder="$t('message.salesman')">
              <el-option v-for="item in $parent.y" :label="item.realname" :value="item.id" :key="item.id">
              </el-option>
            </el-select>
          </div>
          <!-- 采购 -->
          <div class="item">
            <el-select v-model="datas.g_id" clearable filterable :placeholder="$t('message.buyer')">
              <el-option v-for="item in $parent.g" :label="item.realname" :value="item.id" :key="item.id">
              </el-option>
            </el-select>
          </div>

          <!-- 配货员 -->
          <div class="item">
            <el-select v-model="datas.p_id" clearable filterable :placeholder="$t('message.distributionMember')">
              <el-option v-for="item in $parent.p" :label="item.realname" :value="item.id" :key="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="label">
          转移客户ID：
        </div>
        <div class="search">
          <div class="val">
            <el-input v-model="val" size="small" placeholder="请输入客户ID，多个ID使用空格隔开" clearable></el-input>
          </div>
          <el-button size="small" type="primary" class="primary" @click="clientList">{{ $t('message.ok') }}</el-button>
        </div>
        <div class="table">
          <ol>
            <!-- 序号 -->
            <li class="flex05">
              {{ $t("message.serialNumber") }}
            </li>
            <!-- 客户ID -->
            <li>
              {{ $t("message.userID") }}
            </li>
            <!-- 客户名称 -->
            <li>
              {{ $t("message.userName") }}
            </li>

          </ol>
          <ul v-for="(item, index) in tableData" :key="index">
            <!-- 序号 -->
            <li class="flex05">
              {{ index + 1 }}
            </li>
            <!-- 客户ID -->
            <li>
              {{ item.id }}
            </li>
            <!-- 客户名称 -->
            <li>
              {{ item.realname }}
            </li>
          </ul>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      order: false,
      porder: false,
      dialogVisible: false,
      datas: {},
      val: '',
      tableData: [],
    };
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.order = false
        this.porder = false
        this.val = ''
        this.tableData = []
        this.datas = {}
      }
    }
  },
  methods: {
    // 保存
    save() {
      this.datas.userIds = []
      this.tableData.forEach(item => {
        this.datas.userIds.push(item.id)
      })
      if (this.datas.userIds == false) return this.$message.error('未添加转移客户')
      if (!this.order && !this.porder) return this.$message.error('未选择转移的订单、配送单')
      if (this.order) {
        this.$api.clienteleApi.assignClientOrder(this.datas).then((res) => {
          this.dialogVisible = false
          this.$parent.clientList();
        })
      }
      if (this.porder) {
        this.$api.clienteleApi.assignClientPorder(this.datas).then((res) => {
          this.dialogVisible = false
          this.$parent.clientList();
        })
      }
    },
    clientList() {
      let datas = {
        pageSize: 9999,
        id: this.val
      }
      this.$api.clienteleApi.clientList(datas).then((res) => {
        this.tableData = [...this.tableData, ...res.data.data]
        // this.val = ''
      });
    },

  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  .row {
    display: flex;
    margin-bottom: 20px;
    justify-content: space-between;
    line-height: 32px;


  }

  .label {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;

    span {
      color: red;
      margin-left: 50px;
    }
  }

  .staff {
    display: flex;
    margin-bottom: 20px;

    .item {
      flex: 1;
      margin-right: 20px;

      .el-select {
        width: 100%;
      }

      &:nth-last-child(1) {
        margin: 0;
      }
    }
  }

  .search {
    display: flex;
    margin-bottom: 20px;

    .val {
      width: 300px;
      margin-right: 20px;
    }
  }

  .table {
    border: 1px solid #edeff4;

    ol {
      display: flex;
    }

    ul {
      display: flex;
      padding: 0;

      &:nth-last-child(1) {
        border: 0;

      }

      li {
        padding: 10px 0;
      }
    }

    li {
      border-right: 1px solid #edeff4;

      &:nth-last-child(1) {
        border: 0;
      }
    }

    .flex0 {
      flex: 0.5;
    }
  }



  /deep/.el-select {
    .el-input {
      width: 100%;
    }

    width: 80%;
  }
}
</style>